import "./Experience.module.css";
import Header from "@/reusable_sections/Header";
import OurStoryVision from "./sections/OurStoryVision";
import The6StarProcess from "./sections/The6StarProcess";
import Footer from "@/reusable_sections/Footer";
export default function ExperiencePage() {
  return <div>
      <Header />
      <OurStoryVision />
      <The6StarProcess />
      <Footer />
    </div>;
}